import Ajax from '@utils/ajax';

export default {
  index(options = {}) {
    return Ajax.get({
      url: `/welcome_video`,
      ...options,
    });
  },

  disable(options = {}) {
    return Ajax.post({
      url: `/welcome_video/disable`,
      ...options,
    });
  },
};
